<!-- FOOTER SECTION -->
<footer>
	<div class="container">
		<div class="row">

			<div class="row pb-5 align-items-center">
				<div class="col">
					<img src="assets/images/logo/abxp.png" alt="" class="img-fluid">
				</div>
				<div class="col">
					<img src="assets/images/logo/axpn.png" alt="" class="img-fluid">
				</div>
				<div class="col">
					<img src="assets/images/logo/logo-e-market.png" alt="" class="img-fluid">
				</div>
				<div class="col">
					<img src="assets/images/logo/LogoInc.png" alt="" class="img-fluid">
				</div>
				<div class="col">
					<img src="assets/images/logo/partner-jolong.png" alt="" class="img-fluid">
				</div>
				<div class="col">
					<img src="assets/images/logo/rem.png" alt="" class="img-fluid">
				</div>
				<div class="col">
					<img src="assets/images/logo/uniteller.png" alt="" class="img-fluid">
				</div>
			</div>

			<div class="col-md-12 col-sm-12">
				<p class="wow fadeInUp" data-wow-delay="0.6s">Copyright &copy; 1979 7107 Islands </p>

				<ul class="social-icon">
					<li><a href="https://www.facebook.com/7107agencyofficialFB" target="_blank" class="fa fa-facebook wow fadeInUp" data-wow-delay="1s"></a></li>
					<li><a href="#" class="fa fa-twitter wow fadeInUp" data-wow-delay="1.3s"></a></li>
					<li><a href="#" class="fa fa-instagram wow fadeInUp" data-wow-delay="1.6s"></a></li>
					<li><a href="#" class="fa fa-youtube wow fadeInUp" data-wow-delay="1.9s"></a></li>
					<li><a href="#" class="fa fa-google-plus wow fadeInUp" data-wow-delay="2s"></a></li>
				</ul>

			</div>

		</div>
	</div>
</footer>